import config from '@/config'

/*基于权限过滤用户的菜单,目前支持两层菜单*/
export function filterMenuWithOrder(menu, permissions) {
  let filterMenu = []
  filterMenu = menu.filter(item => permissions.indexOf(item.code) >= 0).sort(item => item.order)

  filterMenu.forEach(item => {
    let subMenu = item.subMenu.filter(item => permissions.indexOf(item.code) >= 0).sort(item => item.order)
    item.subMenu = subMenu
  })
  return filterMenu
}

export function filterBreadcrumb(breadcrumbObj, permissions) {
  let filterBreadcrumb = {}
  Object.entries(breadcrumbObj).forEach(([breadName, items]) => {
    filterBreadcrumb[breadName] = items.filter(item => permissions.indexOf(item.routerName) >= 0)
  })
  return filterBreadcrumb
}

export function trimChar(string, charToRemove) {
  while(string.charAt(0)==charToRemove) {
    string = string.substring(1)
  }

  while(string.charAt(string.length-1)==charToRemove) {
    string = string.substring(0,string.length-1)
  }

  return string
}

export function collectMenuPageElement(allMenu, selectedMenu, selectedPageElement) {
  let collectPageElement = []
  function findMenuPageElement(menus, code) {
    for(let i=0; i < menus.length; i++) {
      let menu = menus[i]
      if(menu.code === code && menu.page_element.length > 0) {
        let domCodes = []
        let allDomCodes = menu.page_element.map(item => item.dom_code)
        selectedPageElement.forEach(item => {
          if(allDomCodes.indexOf(item) >= 0){
            domCodes.push(item)
          }
        })

        collectPageElement.push({
          name: menu.name,
          code: menu.code,
          selected: domCodes,
          elements: menu.page_element.map(item => {
            return {
              label: item.dom_name,
              value: item.dom_code
            }
          })
        })
        break
      }else if(menu.child){
        findMenuPageElement(menu.child, code)
      }
    }
  }
  selectedMenu.forEach(item => {
    findMenuPageElement(allMenu, item)
  })
  return collectPageElement
}

export function fileUrl(path) {
  return `${config.ApiServerBaseUrl}${config.fileServerBaseUrl}/${path}`
  // let url = new URL(path, config.fileServerBaseUrl)
  // return url.href
}

let index = 0
// 导出一个名为 generateRandomId 的函数，该函数用于生成随机ID
export function generateRandomId(isInt) {
  // 检查参数 isInt 是否为真，如果是，则生成一个整数类型的ID
  if(isInt) {
    index += 1
    return (new Date().getTime()) + index
  }
  // 获取当前时间的毫秒数
  var d = new Date().getTime();
  var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (d + Math.random()*16)%16 | 0;
    d = Math.floor(d/16);
    return (c=='x' ? r : (r&0x3|0x8)).toString(16);
  });
  // 返回生成的UUID字符串
  return uuid;
}

export function getSingleDefaultYaoPing() {
  return {key: generateRandomId(), name: undefined, value: undefined, unit: undefined, method: undefined, open:false}
}

export function getDefaultYaoPing() {
  return [
    getSingleDefaultYaoPing(),
    getSingleDefaultYaoPing(),
    getSingleDefaultYaoPing(),
    getSingleDefaultYaoPing(),
    getSingleDefaultYaoPing()
  ]
}
export function getSingleDefaultYaoPingZhongyao() {
  return {key: generateRandomId(), name: undefined, dose: undefined, unit: undefined,usage: undefined, method: undefined, open:false}
}
export function getDefaultYaoPingZhongyao() {
  return [
    getSingleDefaultYaoPingZhongyao(),
  ]
}
export function getAppropriateTech() {
  return {
    key: generateRandomId(),
    region_name: undefined,
    position: undefined,
    shen_qian: undefined,
    ci_fa: undefined,
    time: undefined,
    shou_fa: undefined,
    info: undefined,
    region_id:undefined,
    open:false
  }
}

export function getAppropriateTechYaoPin() {
  return [getAppropriateTech()]
}

export function getAppropriateTechOther() {
  return {
    key: generateRandomId(),
    region_name: undefined,
    position: undefined,
    info: undefined,
    region_id: undefined,
    open: false
  }
}

export function getAppropriateTechOtherYaoPin() {
  return [getAppropriateTechOther()]
}


export function refineCommonSymptom(symptomStr) {
  /* 将症状体征转换成规范格式
  *  例如：
  * 【症状1（阴）】说明信息xxx 【症状2】说明信息
  *  输入：症状1(症状减轻),症状2【阴】(注释)
  *  输出：[
  *   {
  *     name: 症状1,
  *     value: 阳,
  *     note: 症状减轻
  *   },
  *   {
  *     name: 症状2,
  *     value: 阴,
  *     note: 注释
  *   }
  * ]
  * */

  let symptoms = symptomStr
    .replace('[', '【')
    .replace(']', '】')
    .split("【")

  let symptomList = []
  let reg = /(?<name>[^（】]+)(（(?<value>.+)）)*】(?<note>.+)*/m

  symptoms.forEach(symptom => {
    symptom = symptom.trim()
    if(symptom.length > 0) {
      let match = reg.exec(symptom)
      if(match) {
        let namedDict = match.groups
        symptomList.push({
          name: namedDict.name,
          value: namedDict.value || '阳性',
          note: namedDict.note || ''
        })
      }
    }
  })
  return symptomList
}

function findStyle(symptom, uiType) {
  let style = null
  if(Array.isArray(uiType)) {
    style = symptom.style_info.find(
      item => item.id === symptom.style_id && uiType.indexOf(item.ui_type) >= 0
    )
  } else {
    style = symptom.style_info.find(
      item => item.id === symptom.style_id && item.ui_type === uiType
    )
  }
  return style
}

let NUMSYMPTOM = 5
let THIRDTOONESYMPTOM = [0, 11]

export function getAllSymptomFromServerGroup(groups) {
  let symptoms = []
  groups.forEach(group => {
    group.symptoms.forEach(symptom => {
      symptom.category_type = group.category_type
      symptoms.push(symptom)
    })
    let childSymptoms = getAllSymptomFromServerGroup(group.children)
    symptoms = symptoms.concat(childSymptoms)
  })
  return symptoms
}

function getAllSymptom(symptomSection) {
  let symptoms = [...symptomSection.firstPageSymptoms, ...symptomSection.otherPageSymptoms]
  return symptoms
}

export function getAllSymptomFromGroup(groups, withGroupName) {
  let symptoms = []
  groups.forEach(group => {
    let allSymptoms = getAllSymptom(group.symptoms)
    if(withGroupName) {
      allSymptoms.forEach(symptom => {
        symptom.group_name = group.name
        symptom.group_id = group.id
      })
    }

    let subSymtoms = getAllSymptomFromGroup(group.children, withGroupName)
    symptoms = symptoms.concat(allSymptoms, subSymtoms)
  })
  return symptoms
}

export function findAllNumberSymptom(groups) {
  let symptoms = []

  groups.forEach(group => {
    let allSymptoms = getAllSymptom(group.symptoms)

    allSymptoms.filter(symptom => symptom.style_id).forEach(symptom => {
      let style = findStyle(symptom, NUMSYMPTOM)
      if(style) {
        symptoms.push({id:symptom.id, name: symptom.name, selected:false})
      }
    })

    let subSymptoms = findAllNumberSymptom(group.children)
    symptoms = symptoms.concat(subSymptoms)
  })
  return symptoms
}

export function findAllMulTo1Symptom(groups) {
  /*
  * {
        key: '4',
        id: 1,
        name: '头痛',
        value0: '-',
        value1: '',
        value2: '',
        value3: ''
      },
  * */
  function patchData(id, name, enums) {
    let values = {}
    let score = 0
    enums.forEach(item => {
      values[item] = {
        info: '',
        score: score ++
      }
    })

    return {
      name,
      symptom_id: id,
      values: values
    }
  }

  function collectSymptoms(groups) {
    let symps = []
    groups.forEach(group => {
      let allSymptoms = getAllSymptom(group.symptoms)

      allSymptoms.filter(symptom => symptom.style_id).forEach(symptom => {
        let style = findStyle(symptom, THIRDTOONESYMPTOM)
        if(style) {
          symps.push(patchData(symptom.id, symptom.name, style.enums))
        }
      })
      let subSymptoms = collectSymptoms(group.children)
      symps = symps.concat(subSymptoms)
    })
    return symps
  }

  return collectSymptoms(groups)
}


export function findSymptomGroup(groups, groupId) {
  let hitGroup = undefined
  for(let i=0;i < groups.length;i++) {
    let group = groups[i]
    if(group.id === groupId) {
      hitGroup = group
      break
    }
    let subGroup = findSymptomGroup(group.children, groupId)
    if(subGroup) {
      hitGroup = subGroup
      break
    }
  }
  return hitGroup
}

export function calculateAge(birthDateString) {
    if(!birthDateString) {
      return undefined
    }
    // 解析出生日期字符串
    const birthDate = new Date(birthDateString);
    // 获取当前日期
    const currentDate = new Date();

    // 计算年龄
    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthDate.getMonth();

    // 如果当前月份小于出生月份或者月份相等但当前日期小于出生日期，则年龄减一
    if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
        age--;
    }
    if(age <= 0) {
      age = 1
    }

    return age;
}


export function checkSymptomGroupRequired(groups, symptomIds){
  let errorResult = {}
  let notSelectedFirstGroupSymptoms = new Set()

  function groupIsRequired(groups, required=false) {
    /*
    * 1  如果症状组1 必填，则他自己的症状或子症状组必须有一个必填
    *
    * */
    let isSelected = false

    groups.forEach(group => {
      let symptomSelected = false
      let symptoms = [...group.symptoms.firstPageSymptoms, ...group.symptoms.otherPageSymptoms]
      let groupSymptomIds = symptoms.map(symptom => symptom.id)
      let firstSymptom = symptoms[0]

      if(groupSymptomIds.find(id => symptomIds.indexOf(id) >= 0)) {
        symptomSelected = true
      }

      let subGroupIsSelected = groupIsRequired(group.children, group.required)

      if(symptomSelected || subGroupIsSelected) {
        isSelected = true
      }

      if(group.required && !symptomSelected && !subGroupIsSelected) {
        errorResult[group.id] = true

        /* 将第一个元素加入列表未选择的列表中 */
        if(firstSymptom) {
          notSelectedFirstGroupSymptoms.add(firstSymptom.id)
        }
      }
    })

    if(required && !isSelected && groups.length > 0) {
      let firstGroup = groups[0]
      let symptoms = [...firstGroup.symptoms.firstPageSymptoms, ...firstGroup.symptoms.otherPageSymptoms]
      let firstSymptom = symptoms[0]

      errorResult[firstGroup.id] = true
      if(firstSymptom) {
        notSelectedFirstGroupSymptoms.add(firstSymptom.id)
      }
    }

    return isSelected
  }
  groupIsRequired(groups)
  return {errorResult, notSelectedFirstGroupSymptoms}
}

/*
* 将症状取值放入症状组里面
* */
export function mergeSelectSymptom(groups, symptom_dict) {
  let allSymptoms = getAllSymptomFromGroup(groups)
  let symptom_keys = Object.keys(symptom_dict);

  const supportTypes = [
    2, // 文本
    5, // 数字
    1, // 多选
  ]
  let refineSymptoms = []

  allSymptoms.filter(
    symptom => symptom_keys.indexOf(symptom.name) >= 0 && supportTypes.indexOf(symptom?.select_style?.ui_type) >= 0
  ).forEach(symptom => {
    refineSymptoms.push({
      id: symptom.id,
      ui_type: symptom.select_style.ui_type,
      value: symptom_dict[symptom.name]
    })
  })
  return refineSymptoms
}


export function deleteSymptomGroup(groups, groupId) {
  let refineGroups = groups.filter(group => group.id !== groupId)

  if (refineGroups.length === groups.length) {
    refineGroups.forEach(group => {
      group.children = deleteSymptomGroup(group.children, groupId)
    })
  }

  return refineGroups
}

/*
获取 文件对应的URL

*/
export function getFileURL(fileInfo) {
  let url = fileInfo.url
  let name = fileInfo.name
  let fileId = fileInfo.id || fileInfo.uid

  if(fileInfo.uri && !url) {
    url = `${config.fileServerBaseUrl}/${fileInfo.uri}`
  } else if(fileInfo.file_type) {
    name = `${fileInfo.id}.${fileInfo.file_type}`
    url = `${config.fileServerBaseUrl}/${name}`
  }

  return {
    uid: fileId,
    name: name,
    status: 'done',
    url: url
  }
}

export function refineFileURL(files) {
  return files.map(fileInfo => {
    return getFileURL(fileInfo)
  })
}


export function checkSymptomGroupIsEmpty(groups) {
  /*
  * 1 如果有子症状组，只需要保证子症状组不为空即可
  * 2 如果没有子症状组，父症状组必须不为空
  * */
  let isEmpty = true

  groups.forEach(group => {
    let subIsEmpty = checkSymptomGroupIsEmpty(group.children)

    let firstPageSymptomsIsEmpty = group.symptoms.firstPageSymptoms.length > 0 ? false : true
    if(firstPageSymptomsIsEmpty && subIsEmpty) {
      isEmpty = true
    } else {
      isEmpty = false
    }
  })

  return isEmpty
}


export function selectStyle(symptom, userId) {
  /*如果有自己创建的症状样式，选择自己创建的，没有的话，选择第一个*/
  let selfStyles = symptom.style_info.filter(style => style.user_id === userId)
  if(selfStyles.length > 0) {
    symptom.style_id = selfStyles[0].id
    symptom.select_style = selfStyles[0]
  } else if(symptom.style_info.length > 0){
    symptom.style_id = symptom.style_info[0].id
    symptom.select_style = symptom.style_info[0]
  } else {
    symptom.select_style = {}
  }
  Object.assign(symptom.select_style, {
    inner_split: 0,
    out_split: 0
  })
}


var vcity = { 11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
  21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",
  33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",
  42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",
  51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",
  63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"
}


//检查号码是否符合规范，包括长度，类型
function isCardNo(card)
{
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/
  if(reg.test(card) === false)
  {
    return false
  }

  return true
}

//取身份证前两位,校验省份
function checkProvince(card)
{
  var province = card.substr(0,2)
  if(vcity[province] == undefined)
  {
    return false
  }
  return true
}

//检查生日是否正确
function checkBirthday(card)
{
  var len = card.length
  //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
  if(len == '15')
  {
    var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
    var arr_data = card.match(re_fifteen)
    var year = arr_data[2]
    var month = arr_data[3]
    var day = arr_data[4]
    var birthday = new Date('19'+year+'/'+month+'/'+day)
    return verifyBirthday('19'+year,month,day,birthday)
  }
  //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if(len == '18')
  {
    var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
    arr_data = card.match(re_eighteen)
    year = arr_data[2]
    month = arr_data[3]
    day = arr_data[4]
    birthday = new Date(year+'/'+month+'/'+day)
    return verifyBirthday(year,month,day,birthday)
  }
  return false
}

//校验日期
function verifyBirthday(year,month,day,birthday)
{
  var now = new Date()
  var now_year = now.getFullYear()
  //年月日是否合理
  if(birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day)
  {
    //判断年份的范围（3岁到100岁之间)
    var time = now_year - year
    if(time >= 3 && time <= 100)
    {
      return true
    }
    return false
  }
  return false
}

//校验位的检测
function checkParity(card)
{
  //15位转18位
  card = changeFivteenToEighteen(card)
  var len = card.length
  if(len == '18')
  {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
    var cardTemp = 0, i, valnum
    for(i = 0; i < 17; i ++)
    {
      cardTemp += card.substr(i, 1) * arrInt[i]
    }
    valnum = arrCh[cardTemp % 11]
    if (valnum == card.substr(17, 1))
    {
      return true
    }
    return false
  }
  return false
}

//15位转18位身份证号
function changeFivteenToEighteen(card)
{
  if(card.length == '15')
  {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
    var cardTemp = 0, i
    card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6)
    for(i = 0; i < 17; i ++)
    {
      cardTemp += card.substr(i, 1) * arrInt[i]
    }
    card += arrCh[cardTemp % 11]
    return card
  }
  return card
}

export function checkCard(num) {
  var card = num
  //是否为空
  if(num === undefined || num === ""){
    return false
  }

  //校验长度，类型
  if(isCardNo(card) === false)
  {
    return false
  }
  //检查省份
  if(checkProvince(card) === false)
  {
    return false
  }
  //校验生日
  if(checkBirthday(card) === false)
  {
    return false
  }
  //检验位的检测
  if(checkParity(card) === false)
  {
    return false
  }
  return true
}

export function validatePassword(value) {
  if(value === "" || value === undefined) {
    return {flag: false, msg: '密码必填！'}
  }

  if(value.length < 8) {
    return {
      flag: false,
      msg: '请确保密码长度大于等于8位!'
    }
  }
  if(value.length > 20) {
    return {
      flag: false,
      msg: '密码长度大于20位！'
    }
  }
  if(value.search(/\d+/g) < 0) {
    return {
      flag: false,
      msg: '密码里面至少有一个数字!'
    }
  }
  if(value.search(/[A-Z]/g) < 0) {
    return {
      flag: false,
      msg: '密码里至少有一个大写字母!'
    }
  }
  if(value.search(/[a-z]/g) < 0) {
    return {
      flag: false,
      msg: '密码里至少有一个小写字母！'
    }
  }
  return {flag: true, msg: ''}
}

export function markLeafNode(nodes) {
  let refineNodes = []
  nodes.forEach(node => {
    if(node.children.length === 0) {
      node.selectable = true
      // node.disabled = false
    } else {
      // node.disabled = true
      node.selectable = false
      node.children = markLeafNode(node.children)
    }
  })
  refineNodes = nodes
  return refineNodes
}

export function moveToElement(symptomId) {
  let element = document.getElementsByClassName(`boxStyle${symptomId}`);
  element.scrollIntoView()
}

export function moveToElementWithAnimation(symptomId) {
  let scrollIntoViewOptions = {"behavior": "smooth", "block": "center"}
  let element = document.getElementById(`sp_wp${symptomId}`);
  element.scrollIntoView(scrollIntoViewOptions)
  let animationEle = document.getElementById(`sp_wp${symptomId}`)
  let oldClass = animationEle.className || ''

  if(oldClass.indexOf("animation") < 0) {
    animationEle.className=`animation ${oldClass}`;
    setTimeout(() => {
      animationEle.className = `${oldClass}`
    },1000)
  }
}

export function moveToElemenColor(symptomId) {
  let scrollIntoViewOptions = {"behavior": "smooth", "block": "center"}
  let element = document.getElementById(`sp_wp${symptomId}`);

  element.scrollIntoView(scrollIntoViewOptions)
  let animationEle = document.getElementById(`sp_wp${symptomId}`)
  let oldClass = animationEle.className || ''

  if(oldClass.indexOf("symptomColor") < 0) {
    animationEle.className=`symptomColor ${oldClass}`;
    setTimeout(() => {
      animationEle.className = `${oldClass}`
    },100000)
  }
}


/* 校验症状的取值
* 1 字段是否为空
* 2 字段范围是否有效
* */
export function validateValue(uiType, relationRequired, value, styleInfo) {
  /* 多选1*/
  let validate = true
  let validateStatus = undefined
  let validateMsg = undefined
  let isEmpty = false
  let validateFirstStatus = undefined
  let validateFirstMsg = undefined
  let validateSecondStatus = undefined
  let validateSecondMsg = undefined

  function setFailed(uiType, msg=" ") {
    validateStatus = "error"
    validateMsg = msg
    validate = false
    console.log(`uiType:${uiType} required`)
  }

  // 隐藏的症状直接通过
  if(!styleInfo?.hidden) {
    if (uiType === 0) {
      isEmpty = !value
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
      /*checkbox*/
    } else if (uiType === 1) {
      isEmpty = !value
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
      /*文本输入框*/
    } else if (uiType === 2) {
      isEmpty = (!value || value.trim().length === 0)
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
      /* 时间框 */
    } else if (uiType === 3) {
      isEmpty = !value
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
      /* 日期 */
    } else if (uiType === 4) {
      isEmpty = !value
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
      /* 数字输入框 */
    } else if (uiType === 5) {
      isEmpty = !value
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      } else if (!isEmpty) {
        let min = styleInfo.min
        let max = styleInfo.max

        value = +value
        if ((min !== null && value < min) || (max !== null && value > max)) {
          setFailed(uiType, `无效数据(${min || ''}-${max || ''})`)
        } else {
          validateStatus = undefined
          validateMsg = undefined
        }
      }
      /* 上传图片 */
    } else if (uiType === 6) {
      isEmpty = !value
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
    } else if (uiType === 7) {
      isEmpty = (!value.low_bp && !value.high_bp)
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      } else if (!isEmpty) {
        let low_bp = value.low_bp
        let high_bp = value.high_bp

        if (low_bp && high_bp) {
          if ((low_bp > 300 || low_bp < 20)) {
            validateSecondStatus = "error"
            validateSecondMsg = "取值超出范围"
            validate = false
            console.log(`uiType:${uiType} range failed 0`)
          }
          if ((high_bp > 300 || high_bp < 20)) {
            validateFirstStatus = "error"
            validateFirstMsg = "取值超出范围"

            validate = false
            console.log(`uiType:${uiType} range failed 1`)
          }

          if (low_bp >= high_bp) {
            validateSecondStatus = "error"
            validateSecondMsg = "低压高于高压！"
            validate = false
            console.log(`uiType:${uiType} range failed 3`)
          }
        }
      }
    } else if (uiType === 8) {
      isEmpty = (!value.year && !value.month && !value.day && !value.hour)
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
    } else if (uiType === 9) {
      isEmpty = (!value.first || !value.second)
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
    } else if (uiType === 10) {
      isEmpty = (!value.first || !value.second)

      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
    } else if (uiType === 11) {
      isEmpty = !value
      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
    } else if (uiType === 12) {
      isEmpty = !value

      if (isEmpty && (relationRequired || styleInfo.required)) {
        setFailed(uiType)
      }
    }
  }

  return {
    validate,
    validateStatus,
    validateMsg,
    validateFirstStatus,
    validateFirstMsg,
    validateSecondStatus,
    validateSecondMsg
  }
}


/* 校验专病下面所有的症状 */
export function validateAllSymptoms(symptoms) {
  let flag = true;
  for(let i=0; i < symptoms.length; i++) {
    let symptom = symptoms[i]
    flag = validateValue(symptom.ui_type, false, symptom.value, symptom.style_info)
    if(!flag) {
      break
    }
  }
  return flag
}


export function clearLocalStorage() {
  let fields = []
  config.localStorageWhiteKeys.forEach(field => {

    let value = localStorage.getItem(field)
    if(value) {
      fields.push([field, value])
    }
  })
  localStorage.clear()
  sessionStorage.clear()
  fields.forEach(([field, value]) => {
    localStorage.setItem(field, value)
  })
}

export function createDefaultInternalSolution(solutionType) {
  /*
  * solutionType 0 内服  1 外用
  * */
  return {
    id: undefined,
    key: generateRandomId(),
    // 贴数
    dose: 7,
    // 服法
    usage: solutionType === 0 ? '水煎服': "外敷",
    // 频次
    duration: "一日2次",
    // 使用顺序
    use_order: "饭后服",
    // 协定方ID
    tpl_id: undefined,
    tpl_name: undefined,
    // 操作手册
    wiki: undefined,
    warning:undefined,
    medicines: getDefaultYaoPing(),
    solution_type: solutionType,
    validate: {
      medicine_msgs: [],
      note_msgs: []
    }
  }
}

export function createMixinDefaultMedicine(editable) {
  return {
    editable,
    "id": undefined,
    "key": generateRandomId(),
    "pin_lv": undefined,
    "usage": undefined,
    "ji_liang": undefined,
    "yong_liang": undefined,
    "gui_ge": undefined,
    "name": undefined,
    "type": undefined,
    "tian_shu": undefined,
    "bao_zhuang": undefined,
    "shu_liang": undefined,
    "note": undefined,
    // "warning":undefined
  }
}
export function createDefaultMixinSolution(editable) {
  return {
    medicines: [
      createMixinDefaultMedicine(true)
    ]
  }
}
export function createFeedDefaultMedicine(editable) {
  return {
    editable,
    "report": true,
    "id": undefined,
    "key": generateRandomId(),
    "pin_lv": undefined,
    "product_unit": undefined,
    "total_dose": undefined,
    "yong_liang": undefined,
    "ji_liang": undefined,
    "name": undefined,
    "note": undefined,
    wiki_info: {}
  }
}
export function createDefaultFeedSolution(editable) {
  return {
    key: generateRandomId(),
    medicines: [
      createFeedDefaultMedicine(true),
      createFeedDefaultMedicine(true),
      createFeedDefaultMedicine(true)
    ]
  }
}
export function createDefaultAppropriateTechSolutionMedicine(){
  let key = generateRandomId()
  return {
    id: key,
    key,
    "region_id": undefined,
    "name": undefined,
    "pin_lv": undefined,
    "position": undefined,
    "shen_qian": undefined,
    "ci_fa": undefined,
    "time": undefined,
    "shou_fa": undefined,
    "info": undefined
  }
}

export function createDefaultAppropriateTechSolution() {
  return {
    id: undefined,
    key: generateRandomId(),
    // 适宜技术
    tech_id: undefined,
    tech_name: undefined,
    category_name: undefined,
    action_type: '毫针类',

    // 协定方
    tpl_id: undefined,
    tpl_name: undefined,

    ci_shu: undefined,
    duration: undefined,

    // 报错消息
    msgs: [],

    // 操作手册
    warning:undefined,
    wiki: undefined,
    medicines: [
      createDefaultAppropriateTechSolutionMedicine(true)
    ]
  }
}

export function create_default_solution(){
  return {
    internal_medicine: [createDefaultInternalSolution(0), createDefaultInternalSolution(1)],
    mixin_medicine: [createDefaultMixinSolution()],
    appropriate_tech_medicine: [createDefaultAppropriateTechSolution()],
    therapeutic_goods_medicine: [createDefaultFeedSolution()]
  }
}

/*清除所有的处置办法*/
export function clear_solution_storage() {
  config.SolutionTypes.forEach(solution => {
    sessionStorage.removeItem(solution)
  })
}

/* 中药是否是口服类型 */
export function isDrinkType(useType) {
  if(config.drinkType.indexOf(useType) >= 0) {
    return true
  } else {
    return false
  }
}

/* 获取echart 图表对应的图片 */
export function getEchartContainerAsImage(echartInstance) {
  return echartInstance.getDataURL()
}

export function downloadBlobDataAsFile(data, fileName) {
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link) //下载完成移除元素
  window.URL.revokeObjectURL(url) //释放掉blob对象
}


export function filterMedicineReleation(data,supportRate, credenceRate, chineseMedicine, num) {
  let table = JSON.parse(JSON.stringify(data))
  let tableData = table.data
  if(supportRate) {
    tableData = tableData.filter(item => item.support_rate >= supportRate)
  }
  if(credenceRate) {
    tableData = tableData.filter(item => item.credence_rate >= credenceRate)
  }
  if(chineseMedicine) {
    tableData = tableData.filter(item => item.name.split(">")[0] === chineseMedicine)
  }
  if(num) {
    tableData = tableData.slice(0, num)
  }

  return {
    data: tableData,
    total: tableData.length
  }
}


export function uiTypeData(ui_type, value_info, styleInfo, symptom_name) {
  /*
  * symptom_name 可以不传
  * */
  let verboseName = undefined
  let symptomImage = undefined
  let tip = ""

  /*没有取值返回空*/
  if(value_info === undefined) {
    return {}
  }

  if (ui_type === 1) {
    if(value_info.value === 1) {
      verboseName = `${symptom_name || '有'}`
    }
  } else if([0, 2, 3, 4, 11, 12].indexOf(ui_type) >= 0){
    let name = symptom_name ? `${symptom_name}: ` : ''
    verboseName = `${name}${value_info.value}`
  } else if (ui_type === 5) {
    let unit = styleInfo.unit || ''
    let name = symptom_name ? `${symptom_name}: ` : ''
    if(+value_info.value < styleInfo.valid_min) {
      tip = "↓"
    }else if(+value_info.value > styleInfo.valid_max) {
      tip = "↑"
    }
    verboseName = `${name}${value_info.value}${unit} ${tip}`
  } else if (ui_type === 6) {
    symptomImage = {
      name: symptom_name,
      images: value_info.files
    }
  } else if (ui_type === 7) {
    let unit = styleInfo.unit || ''
    let high_bp = value_info.high_bp !== undefined ? value_info.high_bp : ''
    let low_bp = value_info.low_bp !== undefined ? value_info.low_bp : ''
    let bpstr = (high_bp === '' || low_bp === '') ? '' : '/'
    let name = symptom_name ? `${symptom_name}: ` : ''

    verboseName = `${name}${high_bp}${bpstr}${low_bp}${unit}`
  } else if (ui_type === 8) {
    let year = value_info.year !== undefined ? value_info.year : ''
    let month = value_info.month !== undefined ? value_info.month : ''
    let day = value_info.day !== undefined ? value_info.day : ''
    let hour = value_info.hour !== undefined ? value_info.hour : ''
    let yearstr = year === '' ? '' : '年'
    if (year == null) {
      year = ''
      yearstr = ''
    }
    let monthstr = month === '' ? '' : '月'
    if (month == null) {
      month = ''
      monthstr = ''
    }
    let daystr = day === '' ? '' : '天'
    if (day == null) {
      day = ''
      daystr = ''
    }
    let hourstr = hour === '' ? '' : '小时'
    if (hour == null) {
      hour = ''
      hourstr = ''
    }
    let name = symptom_name ? `${symptom_name}: ` : ''
    verboseName = `${name}${year}${yearstr}${month}${monthstr}${day}${daystr}${hour}${hourstr}`
  } else if (ui_type === 9 || ui_type === 10) {
    let firstUnit = styleInfo.first.unit || ''
    let secondUnit = styleInfo.second.unit || ''

    let verbose = []
    if (value_info.first !== undefined) {
      verbose.push(`${value_info.first}${firstUnit}`)
    }
    if (value_info.second !== undefined) {
      verbose.push(`${value_info.second}${secondUnit}`)
    }
    verbose = verbose.join("-")
    let name = symptom_name ? `${symptom_name}: ` : ''
    verboseName = `${name}${verbose}`
  }
  return {verboseName, symptomImage}
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

/*
{
   rule_id: {
      case1: true
   }
}
* 解析规则
* rule_id: 标记需要显示这个功能的规则ID
* fact: 对应的哪个场景
check_rule("rule_id", "case1")
* */

export function check_rule(rule_id, fact) {
  let rules = localStorage.getItem("rules")

  if(!rules) {
    return false
  }
  rules = JSON.parse(rules)
  const rule = rules[rule_id]
  if(!rule) {
    return false
  }

  return rule[fact] || false
}


export function refineSolution(solutions) {
  let refineSolutions = {}
  Object.entries(solutions).forEach(([solutionType,solutionInstances]) => {
    if(solutionType === "internal_medicine") {
      refineSolutions.internal_medicine = []
      solutionInstances.forEach(solution => {
        let refineMedicines = []
        solution.medicines.filter(i => i.name).forEach(medicine => {
          if(medicine.method === "煎服" || medicine.method === null || medicine.method === "" || medicine.method === undefined) {
            medicine.method = ""
          } else {
            medicine.method = `（${medicine.method}）`
          }
          refineMedicines.push(medicine)
        })
        solution.tpl_name = !solution.tpl_name ? "": `${solution.tpl_name}加减`

        if(refineMedicines.length > 0) {
          solution.medicines = refineMedicines
          refineSolutions.internal_medicine.push(solution)
        }
      })
    } else if(solutionType === "mixin_medicine") {
      refineSolutions.mixin_medicine = []
      solutionInstances.forEach(solution => {
        let refineMedicines = []
        solution.medicines.filter(i => i.name).forEach(medicine => {
          medicine.type = config.mixinMedicineType[medicine.type]
          medicine.usage = config.mixin_usage[medicine.usage]
          medicine.pin_lv = config.mixin_pin[medicine.pin_lv]
          refineMedicines.push(medicine)
        })
        if(refineMedicines.length > 0) {
          solution.medicines = refineMedicines
          refineSolutions.mixin_medicine.push(solution)
        }
      })
    }else if(solutionType === "therapeutic_goods_medicine") {
      refineSolutions.therapeutic_goods_medicine = []
      solutionInstances.forEach(solution => {
        let refineMedicines = []
        solution.medicines.filter(i => i.name).forEach(medicine => {
          medicine.pin_lv = config.goods_pin[medicine.pin_lv]
          refineMedicines.push(medicine)
        })
        if(refineMedicines.length > 0) {
          solution.medicines = refineMedicines
          refineSolutions.therapeutic_goods_medicine.push(solution)
        }
      })
    }else if(solutionType ==='appropriate_tech_medicine'){
      refineSolutions.appropriate_tech_medicine = []
      solutionInstances.forEach(solution => {
        let refineMedicines = []
        solution.medicines.filter(m => m.position).forEach(medicine => {
          const shoufa = config.shouFaOptions[medicine.shou_fa]
          if(shoufa) {
            medicine.shou_fa = shoufa.label
          }

          medicine.position = config.mixin_distributeds[medicine.position]
          medicine.shen_qian = config.mixin_depths[medicine.shen_qian]
          refineMedicines.push(medicine)
        })
        if(refineMedicines.length > 0) {
          solution.medicines = refineMedicines
          refineSolutions.appropriate_tech_medicine.push(solution)
        }
      })
    }
  })
  return refineSolutions
}

export function base64ToBlob(dataurl) {
  var arr = dataurl.split(',')
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)

  while(n--){
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr],{type:'image/jpeg'})
}

export function blobFile(theBlob,fileName){
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

export function symptomGroupMgrV1(action, groupTree, AddedGroup, CurrentGroup, addType) {
  /*
   添加症状组
   */
  let expandKeys = []

  function findSymptomGroupV1(groups) {
    let hasOpen = false
    for(let i=0;i < groups.length ; i++) {
      let group = groups[i]
      if(group.id === CurrentGroup.id) {
        // 找到了
        if(action === "add") {
          // 并行症状组
          if(addType === 1) {
            AddedGroup.info.level = 1
            groups.splice(i+1, 0, AddedGroup)
          // 子症状组
          } else if(addType === 2) {
            AddedGroup.info.level = 2
            group.children.push(AddedGroup)
            expandKeys.push(group.id)
          }
          hasOpen = true
          expandKeys.push(AddedGroup.id)
        } else if(action === "del") {
            // TODO:
        }
        break
      } else if(group.children.length > 0) {
        let tmp = findSymptomGroupV1(group.children)
        group.children = tmp[0]
        let subHasOpen = tmp[1]

        if(subHasOpen) {
          hasOpen = subHasOpen
          expandKeys.push(group.id)
        }
      }
    }
    return [groups, hasOpen]
  }

  if(groupTree.length === 0) {
    groupTree.push(AddedGroup)
  } else {
    let tmp = findSymptomGroupV1(groupTree)
    groupTree = tmp[0]
  }

  return [groupTree, expandKeys]
}
